import { recursionTrans } from "../../common/util.js";
import formWidgetManager from "@/views/zhiji/js/modules/form/widgets/formWidgetManager.js";
import i18n from "@/i18n";
import { ParamError } from "@/views/zhiji/js/common/errors.js";

/**********
 * 标签管理
 ***********/

// 左边trees客户端数据格式
function transTagTreesData(result) {
    return recursionTrans(
        result,
        function(treesData) {
            return {
                id: "" + treesData.tag_id,
                smallLabel: "" + treesData.tag_id,
                label: treesData.tag_name
            };
        },
        "nodes",
        "children"
    );
}

// 保存trees服务端数据格式
function cvtSaveTreesParam(reqData) {
    return {
        name: reqData.label,
        level: reqData.setLevel,
        parent_id: reqData.classId ? reqData.classId : 0
    };
}

// 移动trees服务端数据格式
function cvtMoveTreesParam(reqData) {
    return {
        id: reqData.classId,
        order: reqData.order
    };
}

// 删除trees服务端数据格式
function cvtDeleteTreesParam(reqData) {
    return {
        id: reqData.id
    };
}

// 更新trees服务端数据格式
function cvtUpdateTreesParam(reqData) {
    return {
        name: reqData.label,
        id: reqData.id
    };
}

/**********
 * 表单管理
 ***********/

// 表单列表客户端数据格式
function transFormListData(result) {
    let ret = {
        total: result.count,
        dataset: []
    };

    ret.dataset = result.list.map(data => {
        const status = {
            "0": i18n.t("zhiji.form.stopped"),
            "1": i18n.t("zhiji.common.normal")
        };
        const formStatus = {
            "0": i18n.t("zhiji.form.normal"),
            "1": i18n.t("zhiji.form.urgency"),
            "2": i18n.t("zhiji.form.auto")
        };
        return {
            name: data.name,
            language: data.lang != "" ? data.lang : i18n.t("zhiji.form.other"),
            formId: data.form_id,
            tag: `${data.parent_tag_name} > ${data.tag_name}`,
            creator: data.creator,
            createTime: data.created_at,
            state: status[data.status],
            rowId: data.form_id,
            firstTag: data.parent_tag_name,
            secondTag: data.tag_name,
            type: formStatus[data.type],
            addData: {
                type: data.type,
                tagIds: data.tag_ids,
                tagId: data.tag_id,
                stateCode: data.status,
                rowId: data.form_id,
                formId: data.form_id,
                lang: data.lang,
                isDefaultForm: data.is_default_form,
            }
        };
    });
    return ret;
}

// 表单列表服务端数据格式
function cvtFormListParam(reqData) {
    return {
        tag_id: reqData.classId ? reqData.classId : "",
        lang: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        status: reqData.status && reqData.status != "all" ? reqData.status : "",
        type: reqData.type && reqData.type != "all" ? reqData.type : "",
        kw: reqData.keyword || "",
        page: reqData.page,
        size: reqData.size || 10
    };
}

// 创建表单服务端数据格式
function cvtCreateFormParam(reqData) {
    let obj = {
        name: reqData.name,
        title: reqData.title,
        tag_id: reqData.tagId,
        lang: reqData.lang ? reqData.lang : "",
        content: cvtFormServerContent(reqData.content),
        type: reqData.formType
    };

    if (reqData.formType == "2") {
        Object.assign(obj, {
            reply_list: JSON.stringify(reqData.autoContents),
            receive: reqData.curRespChannel.join()
        });
    }

    return obj;
}

// 修改表单状态服务端数据格式
function cvtUpdateFormStatusParam(reqData) {
    return {
        form_id: reqData.formId,
        status: reqData.status
    };
}

// 删除表单服务端数据格式
function cvtDeleteFormParam(reqData) {
    return {
        form_id: reqData.formId
    };
}

// 复制表单服务端数据格式
function cvtCopyFormParam(reqData) {
    return {
        form_id: reqData.formId
    };
}

// 设置/取消表单服务端数据格式
function cvtDefaultForm(reqData) {
    return {
        form_id: reqData.formId
    };
}

// 表单详情服务端数据格式
function cvtFormDetailParam(reqData) {
    return {
        form_id: reqData.formId
    };
}

// 表单详情客户端数据格式
function transFormDetailData(result) {
    return {
        formId: result.form_id,
        name: result.name,
        title: result.title,
        lang: result.lang,
        tagId: result.tag_id,
        status: result.status,
        content: cvtFormClientContent(result.fields),
        formType: result.type,
        autoContents: result.reply_list || [],
        curRespChannel: result.receive || []
    };
}

// 表单各种类型组件服务端格式转客户端格式
function cvtFormClientContent(contentJson) {
    let contents = JSON.parse(contentJson);
    let ret = [];
    let roleData = [];
    let newContents = [];
    let roleIdx = 0;
    contents.forEach((content, index) => {
        if (content.name.indexOf(content.type) === -1) {
            roleIdx = index;
            roleData.push(content);
        } else {
            newContents[index] = content;
        }
    });

    if (roleData.length > 0) {
        newContents[roleIdx] = {
            type: "roleMessage",
            roleData: roleData
        };
    }

    newContents.forEach(content => {
        const widgetHandler = formWidgetManager.serverMap[content.type];
        widgetHandler && ret.push(widgetHandler.server2Client.call(null, content));
    });

    return ret;
}

// 修改表单服务端数据格式
function cvtUpdateFormParam(reqData) {
    let obj = {
        form_id: reqData.formId,
        name: reqData.name,
        title: reqData.title,
        tag_id: reqData.tagId,
        lang: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        content: cvtFormServerContent(reqData.content),
        status: reqData.status,
        type: reqData.formType
    };

    if (reqData.formType == "2") {
        Object.assign(obj, {
            reply_list: JSON.stringify(reqData.autoContents),
            receive: reqData.curRespChannel.join()
        });
    }

    return obj;
}

// 表单各种类型组件客户端格式转服务端格式
function cvtFormServerContent(contents) {
    let ret = [];
    let roleData = [];
    let curRoleIdx = 0;
    let curRoleData = [];
    let uploadData = [];

    contents = contents.filter(content => content.updateState != "delete");

    contents.forEach((content, index) => {
        if (content.roleData && content.wtType === "RoleMessage") {
            roleData.push(content.roleData);
            curRoleIdx = index;
            curRoleData = content.roleData;
        }

        if (content.wtType === "UpPicture") {
            uploadData.push(content);
        }

        const widgetHandler = formWidgetManager.clientMap[content.wtType];
        widgetHandler && ret.push(widgetHandler.client2Server.call(null, content));
    });

    moreContentErrorHandle(roleData, uploadData);
    ret = handleFormContentRes(ret, curRoleIdx, curRoleData);

    return JSON.stringify(ret);
}

function handleFormContentRes(ret, curRoleIdx, curRoleData) {
    if (curRoleData.length > 0) {
        ret.splice(curRoleIdx, 1, ...curRoleData);
    }

    ret.forEach((item, index) => {
        let idx = index + 1;
        item.num = idx;
        if (item.name && item.name.indexOf(item.type) != -1) {
            item.name = item.name + idx;
        }
    });
    return ret;
}

function moreContentErrorHandle(roleData, uploadData) {
    if (uploadData.length > 1) {
        throw new ParamError(i18n.t("zhiji.form.upPicture.error.more"));
    }

    if (roleData.length > 1) {
        throw new ParamError(i18n.t("zhiji.form.roleMessage.error.more"));
    }
}

export default {
    transTagTreesData,
    cvtSaveTreesParam,
    cvtMoveTreesParam,
    cvtDeleteTreesParam,
    cvtUpdateTreesParam,
    transFormListData,
    cvtFormListParam,
    cvtCreateFormParam,
    cvtUpdateFormParam,
    cvtUpdateFormStatusParam,
    cvtDeleteFormParam,
    cvtCopyFormParam,
    transFormDetailData,
    cvtFormDetailParam,
    cvtDefaultForm,
};
